import { INavData } from '@coreui/angular';

export const configurationNavBaseItems: INavData[] = [
  {
    name: 'Configuration',
    url: '/game/config',
    iconComponent: { name: 'cil-settings' },
    children: [
      {
        name: 'Languages',
        url: '/backoffice/configuration/languages',
        iconComponent: { name: 'cil-language' },
      },
      {
        name: 'Versions',
        url: '/backoffice/configuration/versions',
        iconComponent: { name: 'cil-layers' },
      },
      {
        name: 'Shop',
        url: '/backoffice/configuration/shop',
        iconComponent: { name: 'cil-basket' },
      },
      {
        name: 'Slots',
        url: '/backoffice/configuration/slots',
        iconComponent: { name: 'cil-star' },
      },
      {
        name: 'Tournaments',
        url: '/backoffice/configuration/tournaments',
        iconComponent: { name: 'cil-chart' },
      },
      {
        name: 'Levels',
        url: '/backoffice/configuration/levels',
        iconComponent: { name: 'cil-layers' },
      },
      {
        name: 'Matchs',
        url: '/backoffice/configuration/matchs',
        iconComponent: { name: 'cil-media-play' },
      },
      {
        name: 'Missions',
        url: '/backoffice/configuration/missions',
        iconComponent: { name: 'cil-task' },
      },
      {
        name: 'Leagues',
        url: '/backoffice/configuration/leagues',
        iconComponent: { name: 'cil-star' },
      },
      {
        name: 'Collections',
        url: '/backoffice/configuration/collections',
        iconComponent: { name: 'cil-grid' },
      },
      {
        name: 'Applications',
        url: '/backoffice/configuration/applications',
        iconComponent: { name: 'cil-puzzle' },
      },
      {
        name: 'Global',
        url: '/backoffice/configuration/global',
        iconComponent: { name: 'cil-settings' },
      },
      {
        name: 'Server Configurations',
        url: '/backoffice/configuration/server-configurations',
        iconComponent: { name: 'cil-cloud-download' },
      },
      {
        name: 'Client Configurations',
        url: '/backoffice/configuration/client-configurations',
        iconComponent: { name: 'cil-cloud-download' },
      },
    ]
  }
];
